export interface RouteStore {
    [routeName: string]: JSX.Element
}

export enum TabNames {
    HOME = 'home',
    TEACHERS = 'teachers',
    SCHOOLS = 'schools',
    ECC_CENTRE = 'ecc-centre',
    ECC_EDUCATOR = 'ecc-educator',
    ABOUT = 'about',
    LOGIN = 'login',
    REGISTER = 'register',
    GUIDES = 'guides',
    HELP_DESK = 'help-desk',
    TERMS_OF_SERVICE = 'terms-of-service',
    // OLD_PROJECT_URL = "user",
    DASHBOARD = 'dashboard',
    TEACHER_REFERAL_PROGRAM = 'teacher-referral-program',
    BlogsHomePage = 'blog',
    RefereeSurveyPage = 'sparkreferee',
    SPARK_USER_BENEFITS = 'spark-user-benefits',
    OnboardingTeacherOptOutPage = 'communications-opt-out',
    ProfessionalLearningResourcePage = 'pdresources',
    SHOP = 'shop',
    CHECK_OUT = 'check-out',
    STRIPT_CHECKOUT_ENDPOINT = 'createCheckoutSession',
    CHECKOUT_SUCCESS = 'checkout-success',
    SHOP_TERMS = 'shop-policies',
    TEACHER_FAQ = 'teacher-frequently-asked-questions',
    SCHOOL_FAQ = 'school-frequently-asked-questions',
    TEACHER_APPLICATION = 'employment-review',
    VERIFY_EMAIL = 'verify',
    REFEREE_SURVEY = 'referee',

    DOC_API = 'docs',
    PAYSLIP_API = 'payslips',

    ON_BOARDING = 'onboarding',
}

export enum DashboardTabNames {
    MY_ACCOUNT = 'my-account',
    REVIEW = 'review',
    SETTINGS = 'settings',
    HELP_DESK = 'help',
    PREEMP = 'preemp',

    MY_CENTRE = 'my-centre',
}

export const SchoolDashTabNames = {
    BOOKINGS: 'bookings',
    MY_SCHOOL: 'my-school',
    BOOKABLE: 'bookable',
} as const
export const SchoolDashTabNames_v2 = {
    BOOKINGS: {
        index: 'bookings',
        all: 'bookings/all',
        upcoming: 'bookings/upcoming',
        date: (e: string, tab?: 'overview' | 'bookable') =>
            `bookings/date/${e}/${tab || 'overview'}`,
    },
    MY_SCHOOL: 'my-school',
    BOOKABLE: 'bookable',
} as const

export const GUIDE_TYPES = {
    TEACHER_GUIDES: 'teacher_guides',
    SCHOOL_GUIDES: 'school_guides',
}

export const RESET_PASSWORD = 'reset-password'

export enum REGISTER_TYPE {
    SCHOOL = 'school',
    TEACHER = 'teacher',
}

export enum SchoolOnBoardingTabNames {
    SELECT = 'select',
    BASIC_DETAILS = 'basic-details',
    INFORMATION = 'info',
    BELL_TIMES = 'bell-times',
    BUSINESS_MANAGER = 'bm',
    SUBMIT = 'submit',
}

export enum ECCOnBoardingTabNames {
    SELECT = 'select',
    BASIC_DETAILS = 'basic-details',
    INFORMATION = 'info',
    SERVICES = 'services',
    LANGUAGES = 'languages',
    AGE = 'age',
    HOURS = 'hours',
    BUSINESS_MANAGER = 'bm',
    SUBMIT = 'submit',
}
